import { apiGatewayClient } from '@/common/apis/client';
import { SuggestionResponse } from './types';

/**
 * Suggestion/state endpoint on ov-booking-control, behind the apigw with the
 * patient's own session. The path is fixed (no GrowthBook override) — the flag
 * that governs this feature is `chat-recovery:online-visit|enabled`, and the
 * server-side allowlist decides which doctors get a payload at all.
 */
export const CHAT_RECOVERY_SUGGESTION_PATH = '/ov-booking-control/v1/chat-recovery/suggestion';

export async function fetchSuggestion(chatId: string): Promise<SuggestionResponse | null> {
  try {
    const res: any = await apiGatewayClient.get(CHAT_RECOVERY_SUGGESTION_PATH, {
      params: { chat_id: chatId },
    });
    return (res?.data ?? null) as SuggestionResponse | null;
  } catch {
    // Fail closed: no connectivity/service means no card, never a broken chat page.
    return null;
  }
}
